// extracted by mini-css-extract-plugin
module.exports = {"Root":"CorporateRadio_Root__2l1fW","RadioItem":"CorporateRadio_RadioItem__UNlcq","RadioInput":"CorporateRadio_RadioInput__V-HJk","Text":"CorporateRadio_Text__1tHoO"};